/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';

/**
 * This component is used to pick a specific package version.
 *
 * @vue-event {Error} error emitted if any error occurs
 * @vue-event {Object} changed emitted when a package and a version are selected
 *
 * @category docs.components
 * @exports PackagePicker
 */
const __vue_script__ = {
    name: 'PackagePicker',

    components: { BaseSelect },

    props: {
        value: {
            type: Object,
            default: () => ({
                pkgName: null,
                version: null
            })
        },
        packages: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            form: {
                pkgName: this.value.pkgName,
                version: this.value.version
            }
        };
    },

    computed: {
        /**
         * Package names for select options
         *
         * @returns {String[]} package names
         */
        packageNames() {
            return Object.keys(this.packages);
        },

        /**
         * Versions for the selected package
         *
         * @returns {String[]} the available versions for the selected package
         */
        versions() {
            // comes already sorted from backend, we just need to copy and reverse it
            return (this.packages[this.form.pkgName] || { versions: [] }).versions.slice();
        }
    },

    watch: {
        value(newVal) {
            this.form.pkgName = newVal.pkgName;
            this.form.version = newVal.version;
        }
    },

    methods: {
        /**
         * Prefill version with latest available when a package is selected
         */
        packageSelected() {
            this.form.version = this.versions[0];

            this.versionSelected();
        },

        /**
         * Handler for when a package name and a version has been selected
         */
        versionSelected() {
            this.$emit('input', this.form);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"package-picker"},[_c('div',{staticClass:"grouped-controls"},[_c('div',{staticClass:"form-groups"},[_c('base-select',{attrs:{"label":_vm.$t('api_docs.packages.picker.name'),"name":"pkgName","options":_vm.packageNames,"options-label":null,"disabled":!_vm.packageNames.length},on:{"input":_vm.packageSelected},model:{value:(_vm.form.pkgName),callback:function ($$v) {_vm.$set(_vm.form, "pkgName", $$v)},expression:"form.pkgName"}}),_c('base-select',{attrs:{"label":_vm.$t('api_docs.packages.picker.version'),"name":"version","options":_vm.versions,"options-label":null,"disabled":!_vm.versions.length},on:{"input":_vm.versionSelected},model:{value:(_vm.form.version),callback:function ($$v) {_vm.$set(_vm.form, "version", $$v)},expression:"form.version"}})],1)])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "PackagePicker.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__